export default __webpack_public_path__ + "static/media/agenda_card.0305b5ab.png";